import React from 'react';

const FormsGeneralTab = ({
  active,
  inputFields,
  renderField,
  appButtonFields = [],
  renderAppButtonField,
}) => {
  const renderActionField = renderAppButtonField || renderField;

  return (
    <div className={`tab-pane fade ${active ? 'show active' : ''}`} role="tabpanel">
      <div className="row g-3">
        {inputFields.map(renderField)}
        {appButtonFields.map(renderActionField)}
      </div>
    </div>
  );
};

export default FormsGeneralTab;
